<homey-page-title-layout>Contact us</homey-page-title-layout>
<p>We’re here to help! Whether you have questions about your application, need assistance with your account, or just
  want to learn more about Homey, feel free to reach out or contact us at <a href="mailto:contact@myhomey.io"
                                                                             class="underline">contact&#64;myhomey.io</a>.
</p>
<homey-custom-form submitButtonLabel="Send" class="mt-8" [formGroup]="form" [submitFunction]="submit">
  <homey-form-inputs>
    <homey-text-input label="Your Name" inputId="name" [type]="{
      type: 'text',
      autocomplete: 'given-name',
    }" [inputFormControl]="form.controls.name"/>
    <homey-text-input label="Your Email" inputId="name" type="email" [inputFormControl]="form.controls.email"/>
    <p-floatlabel variant="on">
      <textarea pTextarea id="message" rows="7" cols="30" style="resize: none" class="w-full" [formControl]="form.controls.message"></textarea>
      <label for="message">Your Message</label>
    </p-floatlabel>
  </homey-form-inputs>
</homey-custom-form>
